import Cognito from '@/cognito/cognito';
import { AuthenticationError } from '@/libs/error';
import Store from '@/store';

function updateSession(session: any) {
  Store.commit('updateSession', session);
}

export async function loadSession() {
  try {
    const session = await getSession();
    updateSession(session);
  } catch (e) {
    updateSession(null);
    throw e;
  }
}

async function getSession() {
  const cognito = new Cognito();
  const user = await cognito.getCurrentUser();
  if (!user) {
    throw new AuthenticationError();
  }
  const session = await cognito.isAuthenticated();
  return session;
}
